import React from 'react'
import { components } from 'react-select'

import FormattedDate from '../../../components/FormattedDate'
import SelectDropdown from '../../../components/SelectDropdown'
import { DROPOVER_TYPES } from '../module'
import { getName } from '../../../containers/Utilities'
import styles from '../EkgRecordingReviewScreen.css'
import CheckmarkIcon from 'static/images/checkmark.svg'

class StackControls extends React.Component {
  UNSAFE_componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick)
  }

  handleClick = e => {
    const {
      handleOnCancelDialogClick,
      selectedDropover,
    } = this.props

    if (selectedDropover !== null
      && (this.reassignRef && !this.reassignRef.contains(e.target))
      && (this.confirmRef && !this.confirmRef.contains(e.target))
      && (this.removeRef && !this.removeRef.contains(e.target))
    ) {
      handleOnCancelDialogClick(selectedDropover)
    }
  }

  render() {
    const {
      showStackRemovalControl,
      handleOnCancelDialogClick,
      handleOnSuccessDialogClick,
      handleOnButtonClick,
      removeFromStackCallback,
      confirmAndArchiveCallback,
      reassignCallback,
      physicianName,
      reassignedInbox,
      currentInboxId,
      inboxOptions,
      updateReassignInboxId,
      inboxIsFetching,
      selectedDropover,
      confirmAndArchiveDisabled,
      me,
      isServiceProviderEnabled,
    } = this.props
    const modifiedInboxOptions = inboxOptions.map(inboxOption => {
      const modifiedOption = inboxOption
      modifiedOption.currentSelection = modifiedOption.id === currentInboxId
      return modifiedOption
    })

    const Option = props => (
      <React.Fragment>
        {props.data.currentSelection ?
          <components.Option {...props}>
            {props.children}
            <CheckmarkIcon
              style={{
                height: '14px',
                float: 'right',
                width: '17px',
              }}
            />
          </components.Option>
          :
          <components.Option {...props}>
            {props.children}
          </components.Option>
        }
      </React.Fragment>
    )

    return (
      <div className={styles.stackControls}>
        <div className={styles.row}>
          <div
            ref={node => { this.reassignRef = node }}
            className={styles.dropoverWrapper}
          >
            <button
              className={styles.reassignButton}
              onClick={() => handleOnButtonClick(DROPOVER_TYPES.STACK_CONTROL_REASSIGN_DIALOG)}
            >
              Reassign
            </button>
            {selectedDropover === DROPOVER_TYPES.STACK_CONTROL_REASSIGN_DIALOG &&
              <div className={styles.reassignDropover} >
                <div className={styles.dropoverContent}>
                  <SelectDropdown
                    autoFocus={true}
                    maxMenuHeight={150}
                    title="Select an inbox to reassign recording"
                    isLoading={inboxIsFetching}
                    isClearable={false}
                    backspaceRemovesValue={false}
                    value={reassignedInbox}
                    onChange={updateReassignInboxId}
                    options={modifiedInboxOptions}
                    noOptionsMessage="No Inbox found"
                    getOptionLabel={p => getName(p.firstName, p.lastName, p.customParticipantID)}
                    getOptionValue={d => d.id}
                    components={{ Option }}
                  />
                </div>
                <div className={styles.dropoverControls}>
                  <button
                    onClick={() => handleOnCancelDialogClick(DROPOVER_TYPES.STACK_CONTROL_REASSIGN_DIALOG, reassignCallback)}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleOnSuccessDialogClick(DROPOVER_TYPES.STACK_CONTROL_REASSIGN_DIALOG, reassignCallback)}
                    disabled={!reassignedInbox || (reassignedInbox && reassignedInbox.id === currentInboxId)}
                  >
                    Reassign
                  </button>
                </div>
              </div>
            }
          </div>
          <div
            ref={node => { this.confirmRef = node }}
            className={styles.dropoverWrapper}
          >
            <button
              className={styles.confirmButton}
              onClick={() => handleOnButtonClick(DROPOVER_TYPES.STACK_CONTROL_CONFIRM_DIALOG)}
              disabled={confirmAndArchiveDisabled}
            >
              Confirm
            </button>
            {selectedDropover === DROPOVER_TYPES.STACK_CONTROL_CONFIRM_DIALOG &&
              <div className={styles.confirmDropover} >
                <div className={styles.dropoverContent}>
                  <h2>
                    <b>
                      {`Confirm as ${physicianName} on `}<FormattedDate
                        overrideLastDay
                        overrideSameDay
                        date={new Date()}
                        me={me}
                      />
                    </b>
                  </h2>
                  <p>
                    'By confirming, you will no longer be able to add interpretations to this ECG.'
                  </p>
                </div>
                <div className={styles.dropoverControls}>
                  <button
                    onClick={() => handleOnCancelDialogClick(DROPOVER_TYPES.STACK_CONTROL_CONFIRM_DIALOG, confirmAndArchiveCallback)}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleOnSuccessDialogClick(DROPOVER_TYPES.STACK_CONTROL_CONFIRM_DIALOG, confirmAndArchiveCallback)}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
        {!isServiceProviderEnabled && showStackRemovalControl && (
          <div className={styles.row}>
            <div
              ref={node => { this.removeRef = node }}
              className={styles.dropoverWrapper}
            >
              <a
                className={styles.removeButton}
                onClick={() => handleOnButtonClick(DROPOVER_TYPES.STACK_CONTROL_REMOVE_DIALOG)}
              >
                Remove from Inbox
              </a>
              {selectedDropover === DROPOVER_TYPES.STACK_CONTROL_REMOVE_DIALOG &&
                <div className={styles.removeFromStackDropover} >
                  <div className={styles.dropoverContent}>
                    <h2>
                      <b>
                        You are about to remove this ECG from the selected inbox
                      </b>
                    </h2>
                    <p>
                      It will still be available in patient's file.
                    </p>
                  </div>
                  <div className={styles.dropoverControls}>
                    <button
                      onClick={() => handleOnCancelDialogClick(DROPOVER_TYPES.STACK_CONTROL_REMOVE_DIALOG, removeFromStackCallback)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => handleOnSuccessDialogClick(DROPOVER_TYPES.STACK_CONTROL_REMOVE_DIALOG, removeFromStackCallback)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default StackControls



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/StackControls.jsx